"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRainbowComponents = require("react-rainbow-components");

var _styled = require("./styled");

var _contentMetaResolver = _interopRequireDefault(require("./contentMetaResolver"));

var AppNotification = function AppNotification(props) {
  var title = props.title,
      description = props.description,
      icon = props.icon,
      timeout = props.timeout,
      onRequestClose = props.onRequestClose;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      shouldExit = _useState2[0],
      setShouldExit = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      contentMeta = _useState4[0],
      updateContentMeta = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      shown = _useState6[0],
      setShown = _useState6[1];

  var scheduleRemove = function scheduleRemove() {
    var removeTimeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 600;
    return setTimeout(function () {
      onRequestClose();
    }, removeTimeout);
  };

  if (timeout) {
    setTimeout(function () {
      setShouldExit(true);
    }, timeout);
    scheduleRemove(timeout + 600);
  }

  var handleCloseRequest = function handleCloseRequest() {
    setShouldExit(true);
    scheduleRemove();
  };

  if (contentMeta) {
    var height = contentMeta.height;
    setTimeout(function () {
      setShown(true);
    }, 0);
    return /*#__PURE__*/_react["default"].createElement(_styled.StyledNotification, {
      height: height,
      shouldExit: shouldExit,
      shown: shown,
      "data-cy": "notification"
    }, /*#__PURE__*/_react["default"].createElement(_reactRainbowComponents.Notification, {
      title: title,
      description: description,
      icon: icon,
      onRequestClose: handleCloseRequest
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_contentMetaResolver["default"], {
    onResolved: updateContentMeta
  }, /*#__PURE__*/_react["default"].createElement(_reactRainbowComponents.Notification, {
    title: title,
    description: description,
    icon: icon,
    onRequestClose: handleCloseRequest
  }));
};

AppNotification.propTypes = {
  /** The icon to show if it is passed. It is displayed in the left of the component.
  * It must be one of this values info, success, warning, error,
  * or any svg icon. */
  icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].oneOf(['info', 'success', 'warning', 'error'])]),

  /** The title that appears in the notification. */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The description that appears in the notification. */
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The action triggered when the close button is clicked. */
  onRequestClose: _propTypes["default"].func,
  timeout: _propTypes["default"].number
};
AppNotification.defaultProps = {
  icon: null,
  title: null,
  description: null,
  onRequestClose: function onRequestClose() {},
  timeout: 2000
};
var _default = AppNotification;
exports["default"] = _default;